/**
 * @description: 我的寄件地址
 * @author: 51fan
 */
<template>
  <div class="addressManageContent main-wrap">
       <div class="main-top">
            <el-button type="primary" class="addAddress h40" @click="rowAdd" icon="iconfont iconxinzeng">{{$lang('新增寄件地址')}}</el-button>
            <div class="searchParam">
                <div class="searchParamInput">
                    <el-input v-model="searchParam" :placeholder="$lang('姓名/联系电话/地址')" style="width:336px !important"></el-input>
                </div>
                <el-button type="primary"  @click="searchChange" icon="iconfont iconchaxun" class="h32 search">{{$lang("查询")}}</el-button>
                <el-button type="primary"  @click="resetSearch" plain icon="iconfont iconshanchu" class="h32">{{$lang("清空")}}</el-button>
                <!--<el-button type="primary" class="addAddress" @click="rowAdd"><i class="iconfont iconxinzeng"></i> 新增寄件地址</el-button> -->
            </div>
       </div>
       <div class="main-table">
            <JmsTableScroll
            :option="listOpt"
            :data="tableList"
            :page="page"
            :table-loading="loading"
            @row-edit="rowEdit"
            @row-del="rowDel"
            @size-change="sizeChange"
            @select-change="selectionChange"
            @current-change="currentChange">
              <template slot="isDefault" slot-scope="data">
                    <el-switch
                                v-model="data.row.isDefault"
                                active-color="#13ce66"
                                inactive-color="#dcdfe6"
                                :active-value="1"
                                :inactive-value="2"
                                disabled>
                    </el-switch>
                </template>
            </JmsTableScroll>
       </div>
    <!-- 编辑地址 -->
    <el-dialog :title="diglogTitle" :visible.sync="editDialogVisible" width="1020px" @close="handleClose" :modal-append-to-body="false"
      :close-on-click-modal="false">
      <el-form class="el-form-edit" ref="tableForm"  :rules="rules" :inline="true" :model="rowData" label-position="left" label-suffix=" :">
        <!-- <el-form-item label="地址识别" class="item-col-4">
          <el-input v-model="analysisAddress" :autosize="{minRows: 5 }"  type="textarea" placeholder="粘贴或者输入整段地址，点击“识别”自动拆分姓名、电话和地址。例如：李小兔，13800138000，上海市黄浦区某某大厦…">
          </el-input>
          <div class="oper">
            <span class="red" @click="discern(0)">智能识别</span>
            <span @click="discern(1)">清空</span>
          </div>
        </el-form-item> -->
        <el-form-item :label="$lang('姓名')" prop="name" class="myDetailItem">
          <el-input v-model="rowData.name"  :minlength="1"  :maxlength="60"  :placeholder="$lang('请填写寄件人姓名')"></el-input>
        </el-form-item>
        <el-form-item class="area-code" label-width="50px" :label="$lang('区号')">
          <el-button plain>+52</el-button>
        </el-form-item>
        <el-form-item :label="$lang('联系电话')" prop="mobile"  class="myDetailItem">
          <el-input v-model="rowData.mobile" :maxlength='10' :placeholder="$lang('请填写寄件人联系电话')"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('公司名称')" prop="companyName" class="myDetailItem">
          <el-input v-model="rowData.companyName" :maxlength="256" :placeholder="$lang('请填写寄件人公司名称')"></el-input>
        </el-form-item>
        <!-- <el-form-item :label="$lang('省/市/区')" prop="province" class="myDetailItem">
          <BaseAddress ref="provinceSearch" :initAddressData="initAddressData" :showLevel="3" v-model="rowData.province"> </BaseAddress>
        </el-form-item> -->
        <el-form-item :label="$lang('邮编')" id="areaCodeSty" prop="postalCode">
            <el-input @blur="postalCodeChange(rowData.postalCode, 3, 1)" v-model.trim="rowData.postalCode" :minlength="1" :maxlength="5"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('州')" prop="provinceName">
          <el-input v-model.trim="rowData.provinceName" readonly></el-input>
          <!-- <el-select v-model="rowData.provinceName" @change="dataProvinceChange($event, 3)">
            <el-option
              v-for="item in provinceList"
              :key="item.id"
              :label="item.nativeName"
              :value="item.id"
            />
          </el-select> -->
        </el-form-item>
        <el-form-item :label="$lang('市')" prop="cityName">
          <el-input v-model.trim="rowData.cityName" readonly></el-input>
          <!-- <el-select v-model="rowData.cityName" @change="dataCityChange($event, 3)">
            <el-option
              v-for="item in cityList2"
              :key="item.id"
              :label="item.nativeName"
              :value="item.id"
            />
          </el-select> -->
        </el-form-item>
        <el-form-item :label="$lang('乡镇')" prop="areaName">
          <el-select v-model="rowData.areaName" @change="dataAreaChange($event, 3)">
            <el-option
              v-for="item in areaList2"
              :key="item.id"
              :label="item.nativeName"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item :label="$lang('邮箱')" id="areaCodeSty" prop="email">
            <el-input v-model.trim="rowData.email" :minlength="1"  :maxlength="60"></el-input>
        </el-form-item>
        <div>
        <el-form-item :label="$lang('详细地址')" prop="detailedAddress" class="addressDeatil">
          <el-input v-model="rowData.detailedAddress" :placeholder="$lang('请填写寄件人所在街道以及详细地址')"  :minlength="1"  :maxlength="256"></el-input>
        </el-form-item>
        <el-form-item :label="$lang('详细地址2')" prop="detailedAddress2" class="addressDeatil">
            <el-input v-model="rowData.detailedAddress2" :placeholder="$lang('请填写收件人所在街道以及详细地址')"  :minlength="1"  :maxlength="256"></el-input>
        </el-form-item>
        </div>
        <el-form-item :label="$lang('设为默认')" prop="isDefault">
          <el-switch v-model="rowData.isDefault" active-color="#13ce66" inactive-color="#ddd"> </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button @click="handleClose('tableForm')">取 消</el-button> -->
        <el-button type="primary" :loading="keyBtn" @click="handleSubmitBefore" class="h40 h104">{{$lang('保存')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS } from '@constants'
// import JmsTableScroll from '@/components/jms-widget/jms-table'
import JmsTableScroll from '@/components/jms-widget/jms-table-scroll'
import mixin from '@/mixins/mixin'
import { addAddress, reqAddressList, updateAddress, delAddress, queryAddressAnalysisAddress } from '@api/module/customer'
import * as Api from '@api/base/public'
import { RULES, phoneAndMobile } from '@utils/rules'
import address from '@/mixins/address'

export default {
  name: 'MailingAddress',
  components: {
    JmsTableScroll,
  },
  mixins: [mixin, address],
  data() {
    return {
      COM_HTTP: {
        reqList: reqAddressList,
        reqAdd: addAddress,
        reqUpdate: updateAddress,
        reqDel: delAddress,
      },
      diglogTitle: this.$lang('新增寄件地址'),
      analysisAddress: '',
      searchParam: '',
      rowData: {
        name: '',
        mobile: '',
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
        detailedAddress: '',
        isDefault: false, // 是否设置为默认地址 1设置默认地址 2 不设置
        type: 1, // 1 寄件 2收件
        id: '',
        companyName: '',
        postalCode: '',
        email: '',
        mobileAreaCode: '+52',
        detailedAddress2: '',
      },
      initAddressData: {
        formProps: {
          provinceIdProp: 'provinceId',
          provinceNameProp: 'provinceName',
          cityIdProp: 'cityId',
          cityNameProp: 'cityName',
          areaIdProp: 'areaId',
          areaNameProp: 'areaName',
        },
        defaultData: {},
      },
      tableList: [],
      isRowDetailUrl: false,
      rules: {
        name: [RULES.requiredTrim, RULES.senderName],
        mobile: [RULES.requiredTrim, { validator: phoneAndMobile }],
        province: [RULES.requiredSelect],
        detailedAddress: [RULES.required, RULES.senderCompany],
        companyName: [RULES.senderCompany],
        email: [RULES.email],
        postalCode: [RULES.required, RULES.postalCode],
        detailedAddress2: [RULES.senderCompany],
        // provinceName: [RULES.requiredSelect],
        // cityName: [RULES.requiredSelect],
        areaName: [RULES.requiredSelect],
      },
      delTitObj: {
        title: this.$lang('删除寄件地址'),
        subTitle: this.$lang('你确定要删除该寄件地址吗？'),
        threeTitle: '',
      },
    }
  },
  computed: {
    listOpt() {
      return {
        fixHeight: 90,
        border: true,
        selection: false,
        menu: true,
        menuWidth: 150,
        rowKey: '$index',
        viewBtn: false,
        column: [
          {
            label: '姓名',
            prop: 'name',
          },
          {
            label: '联系电话', //  扫描员
            prop: 'mobile',
          },
          {
            label: '州',
            prop: 'provinceName',
          },
          {
            label: '城市',
            prop: 'cityName',
          },
          {
            label: '乡镇',
            prop: 'areaName',
          },
          {
            label: '公司名称',
            prop: 'companyName',
          },
          {
            label: '手机区号',
            prop: 'mobileAreaCode',
          },
          {
            label: '邮箱',
            prop: 'email',
          },
          {
            label: '邮编',
            prop: 'postalCode',
          },
          {
            label: '地址1',
            prop: 'detailedAddress',
          },
          {
            label: '地址2',
            prop: 'detailedAddress2',
          },
          {
            label: '是否默认',
            prop: 'isDefault',
            slot: true,
            // formatter: (row, value, label, column) => {
            //   const map = {
            //     1: '<i class="dot green" style="color: #00da00;"></i> ' + '是',
            //     2: '<i class="dot oragin" style="color: #ffa111"></i> ' + '否',
            //   }
            //   return map[row.isDefault]
            // },
          },
        ],
      }
    },
  },
  methods: {
    async handleSubmitBefore() {
      // 表单保存前校验邮编
      const { postalCode } = this.rowData
      const { code, data, msg } = await Api.getSelectByZipCode({ zipCode: postalCode })
      if (code === RESPONSE_SUCCESS && data) {
        // await this.postalCodeChange(this.rowData.postalCode)
        await this.handleSubmit('tableForm')
      } else {
        this.$message.error(msg)
        return false
      }
    },
    viewFun (row) {
      console.log(row)
      // const { provinceId, cityId } = row
      this.rowData = this.handleData(row)
      const { postalCode = '', areaName = '' } = this.rowData
      console.log(this.rowData)
      this.getAreaListData(postalCode, 2, areaName)
    },
    discern(type) {
      let text
      switch (type) {
        case 0:
          console.log(1, { ...this.rowData })
          if (!this.analysisAddress) { return }
          text = this.analysisAddress
          text = text.replace(/\s/g, '')
          queryAddressAnalysisAddress({ text }).then(res => {
            const { code, msg, data } = res
            if (code === RESPONSE_SUCCESS) {
              if (data) {
                const { province, city, county, provinceCode, cityCode, countyCode, detail, phonenum, person } = res.data || {}
                const obj = {
                  name: person,
                  mobile: phonenum,
                  detailedAddress: detail,
                  provinceName: province,
                  provinceId: provinceCode,
                  cityId: cityCode,
                  cityName: city,
                  areaId: countyCode,
                  areaName: county,
                  province: {
                    provinceName: province,
                    provinceId: provinceCode,
                    cityId: cityCode,
                    cityName: city,
                    areaId: countyCode,
                    areaName: county,
                  },
                }
                this.rowData = Object.assign(this.rowData, obj)
                console.log(2, { ...this.rowData })
              }
            } else {
              this.$message.error(msg)
            }
          })
          break
        case 1:
          this.analysisAddress = ''
          break
        default:
          break
      }
    },
    getParams() {
      return {
        type: 1,
        keyword: this.searchParam,
      }
    },
    // 表单保存前
    beforeSubmit() {
      const isDefault = this.rowData.isDefault ? 1 : 2
      // const params = {
      //   name: this.rowData.name.trim(),
      // }
      return { ...this.rowData, isDefault }
    },
    // 弹窗关闭前
    beforehandleClose() {
      this.diglogTitle = this.$lang('新增寄件地址')
    },
    // 重新处理字段不一的查看字段
    handleData(row) {
      this.diglogTitle = this.$lang('编辑地址')
      const { provinceId, provinceName, cityId, cityName, areaId, areaName, isDefault } = row
      const defaultData = { provinceId, provinceName, cityId, cityName, areaId, areaName }
      this.$nextTick(function () {
        this.$set(this.initAddressData, 'defaultData', defaultData)
      })
      return { ...row, isDefault: isDefault === 1, type: 1, province: defaultData, mobileAreaCode: '+52' }
    },
    // 重置搜索
    resetSearch() {
      this.searchParam = ''
    },
    // 重置表单项
    clearFormItem () {
      this.rowData = {
        name: '',
        mobile: '',
        provinceId: '',
        provinceName: '',
        cityId: '',
        cityName: '',
        areaId: '',
        areaName: '',
        detailedAddress: '',
        isDefault: false,
        type: 1,
        id: '',
        mobileAreaCode: '+52',
      }
      this.initAddressData.defaultData.provinceId = ''
      this.initAddressData.defaultData.provinceName = ''
      this.initAddressData.defaultData.cityId = ''
      this.initAddressData.defaultData.cityName = ''
      this.initAddressData.defaultData.areaId = ''
      this.initAddressData.defaultData.areaName = ''
      // this.$refs.provinceSearch.clearInput()
      this.$refs['tableForm'].resetFields()
    },
  },
}
</script>

<style lang="scss" scoped>
.addressManageContent {
  .main-top{
       padding:16px 24px;
  }
  .main-table{
     padding: 12px 24px;
    background: #edeef3;
    flex: 1;
        display: flex;
        flex-direction: column;
  }
  .searchParam {
    display: inline-flex;
    width: 100%;
    position: relative;
    margin-top: 10px;
    .searchParamInput {
      padding-right: 16px;
    }
    .el-button {
      height: 32px;
    }
    .addAddress {
      position: absolute;
      right: 0;
      height: 32px;
    }
  }
  .dot.oragin::before {
    width: 8px;
    height: 8px;
    background: #e60012;
  }
  /*.dot.green::before {*/
  /*  background: #52C41A;*/
  /*}*/
  .el-dialog {
    .el-dialog__body {
      .myDetail {
        display: inline-flex;
        padding: 0 0 24px 0;
        .myDetailItem {
          width: 200px;
          padding: 0 8px;
          .myDetailItemText {
            padding-bottom: 4px;
          }
        }
      }
      .addressDeatil {
        .el-input{
             width: 360px !important;
        }
      }
    }
    .reuqire {
      color: red;
    }
    .el-dialog__header {
      padding: 12px 25px !important;
      border-bottom: 1px solid #eeeeee;
    }
  }
}
.oper{
  position: absolute;
  right: 20px;
  bottom: 5px;
  cursor: pointer;
  color: #333;
  .red{
    color: red;
    margin-right: 20px;
  }
}
</style>
<style lang="scss">
.addressManageContent{
    .el-table__fixed, .el-table__fixed-right{
        height: 705px !important;
    }
}
    .area-code {
      width: 50px !important;
    }
</style>
